import { render } from "./keunggulan.vue?vue&type=template&id=74d5dceb&scoped=true"
import script from "./keunggulan.vue?vue&type=script&lang=js"
export * from "./keunggulan.vue?vue&type=script&lang=js"

import "./keunggulan.vue?vue&type=style&index=0&id=74d5dceb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d5dceb"]])

export default __exports__